// extracted by mini-css-extract-plugin
export var heroImage = "_g6-1";
export var modal = "_g6-0";